"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optionToFilterString = optionToFilterString;
exports.optionToString = optionToString;
var _types = require("../types");
/**
 * @returns contact string representation
 */
function optionToString(option) {
  let returnValue = "";
  if (option) {
    if (option.name) {
      returnValue = option.name;
    } else if (option.emailAddress) {
      returnValue = option.emailAddress;
    }
  }
  return returnValue;
}

/**
 * Converts an option to a string, for use in filtering (for searching through contacts)
 */
function optionToFilterString(option) {
  if (option === null) {
    return "";
  }
  if ((0, _types.isGroupContact)(option)) {
    return `${option.name}`;
  }
  const {
    name = "",
    emailAddress = ""
  } = option;
  return `${name} ${emailAddress}`.toLowerCase();
}
//# sourceMappingURL=optionToString.js.map